import cx from 'classnames'
import React from 'react'

import styles from './index.module.scss'

export function ListItem (props) {
  return (
    <li
      {...props.attributes}
      className={cx(props.attributes.className, styles.listItem)}
      style={props.style}
    >
      {props.children}
    </li>
  )
}
